import { useStore } from "@xyflow/react";
import { useEffect } from "react";

/**
 * Fades the rendered grid out as the camera zooms away — the design
 * system's canvas ground behavior (`showcase/canvas.css` `--cv-grid-fade`):
 * fully visible at ≥50% zoom, gone at ≤30%, linear in between. Every
 * visible grid line is a real snap target (lattice ruling A3), so the
 * grid disappears when its pitch becomes too dense to mean anything
 * rather than shimmering on.
 *
 * Renders nothing; writes `--cv-grid-fade` on the React Flow container.
 */
export function CanvasGridFade() {
  const zoom = useStore((s) => s.transform[2]);
  const domNode = useStore((s) => s.domNode);

  useEffect(() => {
    if (!domNode) return;
    const fade = Math.min(1, Math.max(0, (zoom - 0.3) / (0.5 - 0.3)));
    domNode.style.setProperty("--cv-grid-fade", String(fade));
  }, [domNode, zoom]);

  return null;
}
